import  programming from '../../Images/programming.svg'; 

export const homeObjOne = {
    id : 'about',
    lightBg : false,
    lightText : true,
    lightTextDesc : true,
    topLine : 'TECHNICAL SKILLS',
    headline :'If You Rest, You Rust. So Always Keep Moving.',
    description : "This quote stated by Darius Foroux is a perfect fit for a techie targetting to land on a job in the highly volatile tech industry. After undergoing rigorous training in Full Stack Web Development for the past 6 months, I'm confident enough to say that I'm well versed in MERN Stack Web Development.",
    imgStart : true,
    img : programming,
    alt  :'Coding Skill',
    dark : true,
    primary : true,
    darkText : false
};
